<template>
    <div :style="{'position': 'relative','height':clientHeight-96-53.2-45.5+'px'}" v-loading="parentInfo.studentWeekTable.loading">

        <div style="width: 120px;height: 50px;position: absolute;top: 0;left: 0;z-index: 100;background-color: white"
             :width="120*V4ratio"
             :height="50*V4ratio">
        </div>

        <div class="timeCanvas" style="height: calc(100% - 50px)" ref="timeScroll">
            <canvas ref="timecanvas"
                    :width="V4leftTimeW+V4ratio*2" :height="row*V4rectH+V4ratio*2"
                    :style="{'width':(V4leftTimeW+V4ratio*2)/V4ratio+'px','height':(row*V4rectH+V4ratio*2)/V4ratio+'px','top':(0-parentInfo.studentWeekTable.scroll.top)+'px'}">
            </canvas>
        </div>

        <div class="weekCanvas" style="width: calc(100% - 120px)" ref="weekScrool">
            <canvas ref="weekcanvas"
                    id="weekCanvas"
                    :width="(7)*V4titleW+V4ratio*2" :height="V4titleH"
                    :style="{'width':(((7)*V4titleW+V4ratio*2))/V4ratio+'px','height':(V4titleH)/V4ratio+'px','left':(0-scroll.left+120)+'px'}"></canvas>
        </div>

        <div style="width: calc(100% + 5px);height: calc(100% + 5px)" class="tableCanvas" @scroll="handleScroll">
            <div style="position: relative">
                <div class="auxiliary">
                    <canvas id="auxiliary" ref="auxiliaryCanvas"
                            :width="(7)*V4rectW+V4ratio*2" :height="row*V4rectH+V4ratio*2"
                            :style="{'width':(((7)*V4rectW)+V4ratio*2)/V4ratio+'px','height':(row*V4rectH+V4ratio*2)/V4ratio+'px'}"></canvas>
                </div>
                <div class="mainCanvas" ref="viewBox">
                    <canvas id="timeTable" ref="canvas" v-on:mousedown="handleMousedown"
                            :width="(7)*V4rectW+V4ratio*2" :height="row*V4rectH+V4ratio*2"
                            :style="{'width':(((7)*V4rectW)+V4ratio*2)/V4ratio+'px','height':(row*V4rectH+V4ratio*2)/V4ratio+'px'}"></canvas>
                    <div id="cell"
                         class="scell"
                         v-if="cell.selectable"
                         :style="{'left':(cell.rect[0]*V4rectW)/V4ratio+'px',
                                  'top':(cell.rect[1]*this.V4rectH)/V4ratio+'px',
                                  'width':V4rectW/V4ratio-2+'px',
                                  'height':cell.height+'px'}"
                    >
                    </div>
                    <div class="floatBox"
                         v-if="cell.selectable"
                         :style="{'left':cell.left/V4ratio+'px',
                                  'top':(cell.rect[1]*this.V4rectH)/V4ratio+'px',
                                  'width':V4rectW/V4ratio+'px',
                                  }">
                        <Dialog_ClassDetail></Dialog_ClassDetail>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>
<script>
    import Dialog_ClassDetail from './dialogs/Dialog_ClassDetail'
    export default {
        name: 'v4Table',
        data() {
            return {
                draggable: false,
                borderColor: '#ededed',
                fillStyle: "#555",

                V4titleW: 235 * window.devicePixelRatio,
                V4titleH: 50 * window.devicePixelRatio,
                V4leftTimeW: 120 * window.devicePixelRatio,
                V4rectW: 235 * window.devicePixelRatio,
                V4rectH: 60 * window.devicePixelRatio,
                V4ratio: window.devicePixelRatio,
                cacheH: 90 * window.devicePixelRatio,
                V4divi: 2,
                scroll: {
                    x: 0,
                    y: 0
                },
                startPoint: {
                    x: 1,
                    y: 1
                },
                cell: {
                    rect: [0, 0, 0, 0],
                    subject_id: 0,
                    teacher_id: 0,
                    template_time_id: 0,
                    name: '',
                    classroom_name: '',
                    time: '',
                    color: '',
                    background_color: 'transparent',
                    classPlan_id: '',
                    classHeight: 1,
                    selectable: false,
                    height: 90,
                    section_id: '',
                    left:0,
                    top:0,
                    students:[],
                },
                auxiliaryLine: 6,
                startTime: 8,
                endTime: 23,
                dropCell: {
                    originRect: [0, 0],
                    originClick: false,
                    dropClick: false,
                    timeRect: [0, 0],
                },
                width: 0,
                height: 60,
                top: 0,
                dragResize: false,
                canvas: '',
                scrollLeft:0,
                auxiliaryCanvas: '',
                weekcanvas: '',
                timecanvas: '',
                cachecanvas: '',
            }
        },
        created() {
            this.startPoint = {
                x: this.V4ratio,
                y: this.V4ratio
            };
            this.parentInfo = this.$root.$children[0].$refs['dashboard'].$refs[this.$route.path];
            this.$nextTick(() => {
                this.initCanvas();
            });
        },
        computed: {
            clientHeight() {
                return this.$store.state.config.clientHeight
            },
            clientWidth(){
                return this.$store.state.config.clientWidth
            },
            list() {
                let length = 0;
                return length;
            },
            row() {
                let length = 0;
                for (const key in this.parentInfo.studentWeekTable.basisTime) {
                    if (key > this.parentInfo.studentWeekTable.startTime && key < this.endTime) {
                        length++;
                    }
                }
                return length
            }
        },
        mounted() {
            this.canvas = this.$refs.canvas;
            this.auxiliaryCanvas = this.$refs.auxiliaryCanvas;
            this.weekcanvas = this.$refs.weekcanvas;
            this.timecanvas = this.$refs.timecanvas;
            this.cachecanvas = this.$refs.cachecanvas;
        },
        components: {
            Dialog_ClassDetail,
        },
        methods: {
            //开画
            drawLine(ctx, start = [0, 0], end = [0, 0], lineDash = []) {
                let x = this.startPoint.x;
                let y = this.startPoint.y;
                ctx.beginPath();
                ctx.setLineDash(lineDash);
                ctx.moveTo(start[0] + x, start[1] + y);
                ctx.lineTo(end[0] + x, end[1] + y);
                ctx.stroke()
            },
            drawRect(ctx, x, y, width, height) {
                ctx.fillRect(x + this.startPoint.x, y + this.startPoint.y, width, height);
            },
            drawText(ctx, text, x, y) {
                ctx.fillText(text, x + this.startPoint.x, y + this.startPoint.y);
            },
            initCanvas() {
                this.cell.selectable=false;
                this.clearCanvas();
                this.paintTables();
                this.paintTime();
            },
            clearCanvas() {
                const weekCanvas = this.weekcanvas;
                let ctx = weekCanvas.getContext('2d');
                ctx.clearRect(0, this.V4titleH, 7 * this.V4titleW + this.V4ratio * 2, 2 * this.V4titleH);

                const canvas = this.canvas;
                let cctx = canvas.getContext('2d');
                cctx.clearRect(0, 0, 7 * this.V4rectW + this.V4ratio * 2, this.row * this.V4rectH);
            },
            getFontStyle(size, lineHeight) {
                return 'normal ' + size * this.V4ratio + 'px/' + lineHeight * this.V4ratio + 'px  Microsoft YaHei';
            },
            paintLine() {
                const classCanvas = this.canvas;
                let ctx = classCanvas.getContext('2d');
                ctx.beginPath();
                //课表竖线
                ctx.lineWidth = 2 * this.V4ratio;
                ctx.strokeStyle = "#000";
                this.drawLine(ctx, [0, 0], [0, this.V4rectH * this.row], []);
                this.drawLine(ctx, [10, 0], [10, this.V4rectH * this.row], []);
                this.drawLine(ctx, [20, 0], [20, this.V4rectH * this.row], []);

                this.drawLine(ctx, [0, 0], [1000, 0], []);
                this.drawLine(ctx, [0, 10], [1000, 10], []);
                this.drawLine(ctx, [0, 20], [1000, 20], []);

                ctx.stroke()
            },
            //画时间
            paintTime() {
                const timecanvas = this.timecanvas;
                let ctx = timecanvas.getContext('2d');

                ctx.clearRect(0, 0, this.V4leftTimeW, this.row * this.V4rectH);

                ctx.lineWidth = 1 * this.V4ratio;

                ctx.font = this.getFontStyle(12, 12);

                ctx.fillStyle = this.fillStyle;

                ctx.textAlign = "center";
                ctx.textBaseline = "middle";

                const auxiliaryCanvas = this.auxiliaryCanvas;
                let actx = auxiliaryCanvas.getContext('2d');
                actx.lineWidth = 2 * this.V4ratio;


                let i = 0;
                for (const key in this.parentInfo.studentWeekTable.basisTime) {
                    if (key > this.parentInfo.studentWeekTable.startTime && key < this.endTime) {
                        ctx.fillText(
                            this.parentInfo.studentWeekTable.basisTime[key].content,
                            this.V4leftTimeW / 2,
                            i * this.V4rectH + this.V4rectH / 20
                        );

                        //辅助线
                        actx.beginPath();
                        actx.strokeStyle = 'rgba(220,220,220,0.5)';
                        for (let key in this.parentInfo.studentWeekTable.weeks) {
                            this.drawLine(actx, [key * this.V4titleW, i * this.V4rectH], [key * this.V4titleW + this.V4titleW, i * this.V4rectH], []);
                            for (let j = 1; j < this.auxiliaryLine; j++) {
                                this.drawLine(actx, [key * this.V4titleW, this.V4rectH * i + (this.V4rectH * (j / this.auxiliaryLine))], [key * this.V4titleW + this.V4titleW, this.V4rectH * i + (this.V4rectH * (j / this.auxiliaryLine))], [5]);
                            }

                        }
                        actx.stroke()
                        i++;
                    }
                }

                ctx.stroke()
            },

            //画表
            paintTables() {
                const canvas = this.canvas;
                let ctx = canvas.getContext('2d');
                ctx.clearRect(0, 0, (this.list + 1) * this.V4rectW, this.row * this.V4rectH);
                ctx.textAlign = "center";
                ctx.textBaseline = "middle";
                for (let key in this.parentInfo.studentWeekTable.weeks) {
                    let week = this.parentInfo.studentWeekTable.weeks[key];
                    this.paintWeeks(week, key);
                    this.paintClass(key, week);
                }
            },
            //画学科
            paintWeeks(week, key) {
                const subjectCanvas = this.weekcanvas;
                let ctx = subjectCanvas.getContext('2d');
                let circle = subjectCanvas.getContext('2d');
                ctx.globalAlpha = 0.5;
                ctx.clearRect(key * this.V4titleW, 0, this.V4titleW, this.V4titleH);
                ctx.fillStyle = 'rgba(0,0,0,0.5)';
                this.drawRect(ctx, key * this.V4titleW, 0, this.V4titleW, this.V4titleH);

                ctx.font = 'bold ' + 15 * this.V4ratio + 'px/' + 15 * this.V4ratio + 'px  Microsoft YaHei';
                ctx.textAlign = "center";
                ctx.textBaseline = "middle";
                ctx.fillStyle = 'black'

                let day=this.$moment(week.date).format('DD')
                if(week.date==this.parentInfo.studentWeekTable.filter.date){
                    circle.strokeStyle = '#1E90FF';
                    circle.fillStyle = "#1E90FF";
                    circle.arc(key * this.V4titleW + 2*this.V4titleW / 5, this.V4titleH / 2, 12 * window.devicePixelRatio, 0, 360);
                    this.drawText(circle, day, key * this.V4titleW + 2*this.V4titleW / 5, this.V4titleH / 2)
                }else{
                    circle.fillStyle = 'rgba(0,0,0,0.5)';
                    this.drawText(circle, day, key * this.V4titleW + 2*this.V4titleW / 5, this.V4titleH / 2)
                }

                this.drawText(ctx, week.name, key * this.V4titleW + this.V4titleW / 2+4 * window.devicePixelRatio, this.V4titleH / 2)
                ctx.stroke()

            },
            //画班级
            paintClass(i, week) {
                if (this.parentInfo.studentWeekTable.classes[week.date]) {
                    let classes = this.parentInfo.studentWeekTable.classes[week.date];
                    const classCanvas = this.canvas;
                    let ctx = classCanvas.getContext('2d');

                    ctx.beginPath();
                    ctx.lineWidth = 2 * this.V4ratio;
                    ctx.font = this.getFontStyle(12, 15);
                    ctx.fillStyle = '#555';
                    ctx.textAlign = "center";
                    ctx.textBaseline = "middle";

                    for (let start_time in classes) {
                        let classes_time = classes[start_time];
                        if(classes_time.length>1){
                            var classHeight = classes_time[0].end_sort - classes_time[0].start_sort;
                            ctx.fillStyle = 'red';
                            ctx.globalAlpha = 0.05;
                            ctx.fillRect(i * this.V4rectW, (classes_time[0].start_sort - this.parentInfo.studentWeekTable.startTime) * this.V4rectH,
                                this.V4rectW, classHeight * this.V4rectH);
                            ctx.globalAlpha = 1;
                            this.drawText(ctx, '重复',
                                    i * this.V4rectW + this.V4rectW / 2,
                                    (classes_time[0].start_sort - this.parentInfo.studentWeekTable.startTime) * this.V4rectH + classHeight * this.V4rectH / this.V4divi * (5/6));
                        }else{
                            let classx=classes[start_time][0]
                            var classHeight = classx.end_sort - classx.start_sort;

                            if (this.parentInfo.studentWeekTable.filter.grade_id.length !== 0) {
                                if (this.parentInfo.studentWeekTable.filter.grade_id.includes(classx.grade_id)) {
                                    ctx.fillStyle = classx.color;
                                } else {
                                    ctx.fillStyle = '#ededed';
                                }
                            } else {
                                if (![3, 6].includes(classx.class_type_id)) {
                                    ctx.fillStyle = '#FF0000';
                                } else {
                                    ctx.fillStyle = classx.color;
                                }
                            }

                            ctx.globalAlpha = 0.05;
                            ctx.fillRect(i * this.V4rectW, (classx.start_sort - this.parentInfo.studentWeekTable.startTime) * this.V4rectH,
                                this.V4rectW, classHeight * this.V4rectH);
                            ctx.globalAlpha = 1;

                            for (let d = 0; d < 1; d++) {
                                var class_name=classx.class
                                if(classx.class_status=='cart'){
                                    class_name=class_name+'(未买)';
                                }
                                //班级名
                                this.drawText(ctx, class_name,
                                    i * this.V4rectW + this.V4rectW / 2,
                                    (classx.start_sort - this.parentInfo.studentWeekTable.startTime) * this.V4rectH + classHeight * this.V4rectH / this.V4divi * ((d ? 2 : 2) / 5));


                                this.drawText(ctx, classx.teacher,
                                    i * this.V4rectW + this.V4rectW / 2,
                                    (classx.start_sort - this.parentInfo.studentWeekTable.startTime) * this.V4rectH + classHeight * this.V4rectH / this.V4divi * ((d ? 2: 2) / 5) + 20 * window.devicePixelRatio)


                                //教室名
                                var secondName = classx.classroom_name ? classx.classroom_name : '无'
                                if (this.parentInfo.studentWeekTable.filter.section_id != classx.section_id) {
                                    secondName = classx.section_name
                                }
                                this.drawText(ctx, secondName,
                                    i * this.V4rectW + this.V4rectW / 2,
                                    (classx.start_sort - this.parentInfo.studentWeekTable.startTime) * this.V4rectH + classHeight * this.V4rectH / this.V4divi * ((d ? 2 : 2) / 5) + 40 * window.devicePixelRatio)


                                this.drawText(ctx, classx.status_name,
                                    i * this.V4rectW + this.V4rectW / 2,
                                    (classx.start_sort - this.parentInfo.studentWeekTable.startTime) * this.V4rectH + classHeight * this.V4rectH / this.V4divi * ((d ? 2: 2) / 5) + 60 * window.devicePixelRatio)


                                if (d === 1)
                                    break;
                            }

                        }

                    }
                    ctx.stroke();
                }


            },
            //滚轮滚动
            handleScroll(e) {
                this.scrollLeft=e.target.scrollLeft;
                this.$refs.weekScrool.scrollLeft = e.target.scrollLeft;
                this.$refs.timeScroll.scrollTop = e.target.scrollTop;
                this.$emit('cartScroll', e.target.scrollTop)
                this.cell.visible = false;
            },
            getPara(inx, iny) {
                const x = inx * this.V4ratio;
                const y = iny * this.V4ratio;
                const px = Math.floor(x / this.V4rectW);
                const py = parseFloat((y / this.V4rectH).toFixed(1));


                let date = '';
                for (let key in this.parentInfo.studentWeekTable.weeks) {
                    if (key == px) {
                        date = this.parentInfo.studentWeekTable.weeks[key].date;
                        break;
                    }
                }

                return {
                    date: date,
                    rect: [px, py, 1, 1],
                }
            },

            handleMousedown(evt) {
                if (evt.button === 1) {
                    this.cell.visible = false;
                    return;
                }

                let {date, rect} = this.getPara(evt.offsetX, evt.offsetY);

                this.cell = {
                    rect: rect,
                    name: '',
                    visible: true,
                    classHeight: 1,
                    classroom_name: '',
                    remark: '',
                    section_id: '',
                    background_color: 'transparent',
                    height: this.V4rectH / this.V4ratio,
                    date:date,
                    selectable:false,
                    students:[],
                };

                let data = {
                    'type': 'blank',
                    'date':date,
                    'startSort': 0,
                    'classx': ''
                };
                if (this.parentInfo.studentWeekTable.classes[date]) {
                    for (var key in this.parentInfo.studentWeekTable.classes[date]) {
                        let time_classes=this.parentInfo.studentWeekTable.classes[date][key]
                        if(time_classes.length==1){
                            let startSort = time_classes[0].start_sort - this.parentInfo.studentWeekTable.startTime
                            let endSort = time_classes[0].end_sort - this.parentInfo.studentWeekTable.startTime
                            if (rect[1] >= startSort && rect[1] <= endSort) {
                                let classx = time_classes[0];
                                data.type = 'class';
                                this.cell.name = classx.class.slice(0, 8);
                                this.cell.classPlan_id = classx.class_plan_id;
                                this.cell.color = classx.color;
                                this.cell.classroom_id = classx.classroom_id;
                                this.cell.remark = classx.remark;
                                this.cell.section_id = classx.section_id;

                                data.startSort = startSort;
                                this.cell.rect[1] = startSort;
                                this.cell.classHeight = endSort - startSort;
                                this.cell.classroom_name = classx.classroom_name ? classx.classroom_name.slice(4, 20) : '无';
                                this.cell.time = (parseInt(startSort) + this.parentInfo.studentWeekTable.startTime) + ':' +
                                    (((startSort - parseInt(startSort)) * 60).toPrecision(2) == 0 ? "00" : ((startSort - parseInt(startSort)) * 60).toPrecision(2));
                                this.cell.height = (endSort - startSort) * this.V4rectH / this.V4ratio;
                                this.cell.background_color = 'white';

                                this.cell.left=this.cell.rect[0]*this.V4rectW;
                                if(this.clientWidth-((this.cell.rect[0]*this.V4rectW+this.V4leftTimeW)/this.V4ratio+50)+this.scrollLeft<=2*this.V4rectW/this.V4ratio){
                                    this.cell.left=this.cell.left-this.V4rectW;
                                }else{
                                    this.cell.left=this.cell.left+this.V4rectW;
                                }
                                this.cell.selectable=false;
                                break;
                            }
                        }else{
                            let startSort = time_classes[0].start_sort - this.parentInfo.studentWeekTable.startTime
                            let endSort = time_classes[0].end_sort - this.parentInfo.studentWeekTable.startTime
                            if (rect[1] >= startSort && rect[1] <= endSort) {
                                let classx = time_classes[0];
                                data.startSort = startSort;
                                this.cell.classes = time_classes;
                                for (var id in this.cell.classes) {
                                    if(!this.cell.classes[id].classroom_name){
                                        this.cell.classes[id].classroom_name='无'
                                    }
                                }
                                this.cell.rect[1] = startSort;
                                this.cell.classHeight = endSort - startSort;
                                this.cell.height = (endSort - startSort) * this.V4rectH / this.V4ratio;
                                this.cell.background_color = 'white';

                                this.cell.left=this.cell.rect[0]*this.V4rectW;
                                if(this.clientWidth-((this.cell.rect[0]*this.V4rectW+this.V4leftTimeW)/this.V4ratio+50)+this.scrollLeft<=2*this.V4rectW/this.V4ratio){
                                    this.cell.left=this.cell.left-this.V4rectW;
                                }else{
                                    this.cell.left=this.cell.left+this.V4rectW;
                                }
                                this.cell.selectable=true;
                            }

                        }
                    }
                }

                if (data.type == 'blank') {
                    for (const key in this.parentInfo.studentWeekTable.timeData) {
                        if (rect[1] >= this.parentInfo.studentWeekTable.timeData[key].sort[0] - this.parentInfo.studentWeekTable.startTime && rect[1] <= this.parentInfo.studentWeekTable.timeData[key].sort[1] - this.parentInfo.studentWeekTable.startTime) {
                            this.cell.rect[1] = this.parentInfo.studentWeekTable.timeData[key].sort[0] - this.parentInfo.studentWeekTable.startTime;
                            this.cell.classHeight = this.parentInfo.studentWeekTable.timeData[key].sort[1] - this.parentInfo.studentWeekTable.timeData[key].sort[0];
                            this.cell.height = (this.parentInfo.studentWeekTable.timeData[key].sort[1] - this.parentInfo.studentWeekTable.timeData[key].sort[0]) * this.V4rectH / this.V4ratio
                        }
                    }
                }
                return this.$emit('handleMouseDown', data);
            },
        },
        beforeDestroy() {

        }
    }
</script>
<style scoped lang="scss">
    $border-color: #ededed;
    .canvas-border {
        border: 2px solid $border-color;
    }

    .timeCanvas {
        &::-webkit-scrollbar {
            width: 0px;
            height: 0px;
        }
        canvas {
            background: #fff;
        }
        z-index: 10;
        background: #fff;
        position: absolute;
        top: 50px;
        overflow: auto;
        .item {
            &:last-of-type {
                border-bottom: 1px solid #555;
            }
            height: 50px;
            border-top: 1px solid #555;
            border-left: 1px solid #555;
            border-right: 1px solid #555;
            text-align: center;
            box-sizing: border-box;
        }
    }

    .weekCanvas {
        &::-webkit-scrollbar {
            width: 0px;
            height: 0px;
        }
        canvas {
            background: #fff;
        }
        z-index: 10;
        position: absolute;
        left: 120px;
        top: 0px;
        overflow: auto;
    }

    .mainCanvas {
        position: absolute;
        left: 120px;
        top: 50px;
    }

    .cacheCanvas {
        width: 120px;
        height: 100px;
        position: absolute;
        top: 0;
        left: 0;
        background: #fff;
        z-index: 1;
    }

    .auxiliary {
        position: absolute;
        left: 120px;
        top: 50px;
    }

    .subjectcontent {
        position: relative;
        float: left;
        margin: 0 2px;
    }

    .scell {
        z-index: 1;
        display: table;
        cursor: pointer !important;
        position: absolute;
        background: transparent;
        color: #555;
        width: 102px;
        border: 2px solid rgb(141, 193, 245);
        border-radius: 2px;
        .scellContent {
            position: absolute;
            width: 100%;
            font-size: 12px;
            font-family: 'Microsoft Yahei UI';
            z-index: 0;
            pointer-events: none;
        }
    }

    .scell span {
        display: table-cell;
        vertical-align: middle;
        text-align: center;
        font-size: 12px;
        line-height: 15px;
        font-weight: 400;
        font-family: 'Microsoft Yahei UI';
        position: relative;

    }

    .studentCell {
        display: table;
        position: absolute;
        background: transparent;
        color: #555;
        z-index: 1200;
        width: 44px;
        height: 20px;
        border: 2px solid rgb(141, 193, 245);
        border-radius: 2px;
    }

    .timeCell {
        color: red;
        width: 50px;
        height: 20px;
        z-index: 1;
        display: table;
        cursor: pointer !important;
        position: absolute;
        background: transparent;
        pointer-events: none;
    }

    .dragging {
        cursor: pointer !important;
    }

    .tableCanvas {
        &::-webkit-scrollbar {
            width: 5px;
            height: 5px;
        }
        position: absolute;
        overflow: scroll;
    }

    .floatBox {
        display: table;
        position: absolute;
        background: transparent;
        color: #555;
        z-index: 0;
    }
</style>
